import * as React from "react";

import { useDispatch, useSelector } from "react-redux";

import useTranslations from "../../hooks/useTranslations";
import TLang, { TConfirmModalLang } from "../../model/application/Lang";
import { hideRefreshModalActionCreator } from "../../redux/actionCreators/appActionCreator";
import IRootState from "../../redux/store/model";
import CustomDialogWarning from "../Dialog/CustomDialogWarning";

/**
 * GlobalUpdateDialog
 * ------------------
 * Mounted once at the app root. Watches Redux state for update/migration
 * dialog flags and renders the appropriate `UpdateNotificationDialog`.
 * This component wires the dialog confirm/close actions to redux or
 * window reload behavior.
 */
const GlobalUpdateDialog: React.FC = () => {
  const rootLang = useTranslations();
  const dispatch = useDispatch();
  const refreshModal = useSelector((s: IRootState) => s.app.refreshModal);

  const messages =
    rootLang.components.updateMonitor.createEditModal.updateMonitor
      .customMessage;

  const updateModalLang: TConfirmModalLang = {
    title: messages.newVersionAvailableTitle,
    description: messages.newVersionAvailableDescription,
  };

  const migrationModalLang: TConfirmModalLang = {
    title: messages.migrationOngoingTitle,
    description: messages.migrationOngoingDescription,
  };

  const isOpen = !!refreshModal?.isOpen;
  const modalLang =
    refreshModal?.variant === "migration"
      ? migrationModalLang
      : updateModalLang;

  return (
    <CustomDialogWarning
      lang={modalLang}
      rootLang={rootLang as TLang}
      isOpen={isOpen}
      confirmBtnText={rootLang.actions.reload}
      onConfirmAction={() => {
        if (refreshModal?.variant === "migration") {
          // close the modal and let app behavior decide
          dispatch(hideRefreshModalActionCreator());
        } else {
          //reset the redux state before reloading, otherwise the modal will re-appear
          dispatch(hideRefreshModalActionCreator());
          window.location.reload();
        }
      }}
      hideCancelButton
      onClose={() => dispatch(hideRefreshModalActionCreator())}
    />
  );
};

export default GlobalUpdateDialog;
